import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export const palette = {
  grey: "rgba(0, 0, 0, 0.18)",
  darkGrey: "#474854",
  primaryObsolete: "#f8bc00",
  // primary: "#4E944F",
  primary: "#354763",

  primaryDark: "#69302c",
  honey: "#da7b08",
  secondary: "#8ba6bc",
  secondaryDark: "#404664",
  success: "#4caf50",
};

export const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: palette.primary,
      },
      secondary: {
        main: palette.secondary,
      },
    },
    // typography: {
    //   fontSize: 14,
    //   fontFamily: [
    //     "Google Sans",
    //     "-apple-system",
    //     "BlinkMacSystemFont",
    //     '"Segoe UI"',
    //     "Roboto",
    //     '"Helvetica Neue"',
    //     "Arial",
    //     "sans-serif",
    //     '"Apple Color Emoji"',
    //     '"Segoe UI Emoji"',
    //     '"Segoe UI Symbol"',
    //   ].join(","),
    // },
    // props: {
    //   MuiButton: {
    //     disableElevation: true,
    //   },
    //   MuiTooltip: {
    //     arrow: true,
    //   },
    // },
    // overrides: {
    //   MuiTooltip: {
    //     arrow: { color: palette.darkGrey },
    //     tooltip: { backgroundColor: palette.darkGrey, fontSize: "0.8em" },
    //   },
    //   MuiTypography: {
    //     h4: {
    //       fontWeight: 400,
    //     },
    //   },
    // },
  })
);
